import styled from '@emotion/styled';
import { spacing, color } from '@lightspeed/cirrus-tokens/utils';

export const MenuContainer = styled('ul')`
  margin: 0;
  padding: ${spacing(1)} 0;
  list-style: none;
`;

export const MenuItemContainer = styled('li')``;

export const MenuItemButton = styled('a')`
  display: block;
  white-space: nowrap;
  cursor: pointer;
  padding: ${spacing(1)} ${spacing(3)};

  &:hover {
    background-color: ${color('snow-200')};
  }
`;
